import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class ParityStrategySubscription extends Model {
  [Type] = 'parity-strategy/subscription' as const;

  @attr('string') declare brandCode: string;
  @attr('string') declare name: string;
}
